const selectionValue = (selection, keys) => {
  for (const key of keys) {
    const value = selection?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }
  return "";
};

export const normalizePgaStat = (statKey) => {
  const normalized = String(statKey || "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .toLowerCase()
    .replace(/^(projected_|promo_|goblin_|demon_)/, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");

  return {
    birdie_or_better: "birdies_or_better",
    birdies_better: "birdies_or_better",
  }[normalized] || normalized;
};

export const getPgaRound = (value) => {
  if (Number.isInteger(Number(value)) && Number(value) > 0 && Number(value) <= 9) {
    return Number(value);
  }
  const match = String(value || "").match(/\b(?:rd|round)\s*[-#:]?\s*([1-9])\b/i);
  return match ? Number(match[1]) : 0;
};

export const normalizePgaTournamentId = (value) => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/\s*[-–—:]?\s*\b(?:rd|round)\s*[-#:]?\s*[1-9]\b\s*$/i, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "_")
  .replace(/_+/g, "_")
  .replace(/^_+|_+$/g, "");

export const getPgaRoundDateKey = (selection) => {
  const value = selectionValue(selection, [
    "start_time_iso",
    "start_time_obj",
    "start_time",
  ]);
  const match = String(value || "").match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) {
    return `date_${match[1]}`;
  }

  const timestamp = Date.parse(String(value || ""));
  return Number.isFinite(timestamp)
    ? `date_${new Date(timestamp).toISOString().slice(0, 10)}`
    : "";
};

export const getPgaCanonicalIdentity = (selection) => {
  const league = String(selection?.league || selection?.sport || "").trim().toLowerCase();
  if (league !== "pga") {
    return null;
  }

  const authoritativeTournament = selectionValue(selection, [
    "tournament_id",
    "tournamentId",
    "event_id",
    "eventId",
    "event_name",
    "eventName",
    "tournament_name",
    "tournamentName",
    "opponent_name",
    "opponent_short",
    "opponent",
  ]);
  const tournamentSource = authoritativeTournament || selectionValue(selection, [
    "game_id",
    "gameId",
  ]);
  const roundCandidates = [
    selection?.round,
    selection?.round_number,
    selection?.roundNumber,
    selection?.event_round,
    selection?.eventRound,
    selection?.period,
    selection?.game_id,
    selection?.gameId,
    selection?.event_id,
    selection?.eventId,
    selection?.event_name,
    selection?.eventName,
    selection?.opponent_short,
    selection?.opponent,
    selection?.location,
  ];
  const round =
    roundCandidates.map(getPgaRound).find((value) => value > 0) ||
    getPgaRoundDateKey(selection);
  const stat = normalizePgaStat(selectionValue(selection, [
    "stat_key",
    "statType",
    "stat_type",
    "market_type",
    "marketType",
  ]));
  const tournamentId = normalizePgaTournamentId(tournamentSource);

  if (!tournamentId || !round || !stat) {
    return null;
  }

  return {
    tournamentId,
    round,
    normalizedStat: stat,
    eventKey: `pga|tournament:${tournamentId}|round:${round}`,
    key: `${tournamentId}|round:${round}|stat:${stat}`,
  };
};

export const hasTooManyPgaSameEventStatPicks = (selected) => {
  const counts = new Map();
  for (const selection of Array.isArray(selected) ? selected : []) {
    const identity = getPgaCanonicalIdentity(selection);
    if (!identity) {
      continue;
    }
    const count = (counts.get(identity.key) || 0) + 1;
    if (count > 2) {
      return true;
    }
    counts.set(identity.key, count);
  }
  return false;
};
